/* eslint-disable react/jsx-curly-newline */
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import Logotipo from '@resources/imgs/logo-proseed.webp'
import Iconlogo from '@resources/imgs/icon-proseed.png'
import PanelContext from '@contexts/Panel'
import { LuChevronLeft, LuChevronRight, LuHome, LuList, LuUser, LuHeart, LuShoppingCart, LuHeartPulse, LuHelpCircle, LuMessageCircle, LuLogOut, LuPackage } from 'react-icons/lu'
import AuthContext from '@contexts/Auth'
import { displayOnProduction } from '@helpers/Utils'

const Sidebar: React.FC<any> = () => {
  const { user, cartCount, favoritesCount, inProgressOrders, logout } = useContext(AuthContext)
  const { activeMenu, menuOpen, setMenuOpen, collapsed, setCollapsed } = useContext(PanelContext)

  const isActivated = (path: string) => activeMenu === `/${path}` ? 'activated' : ''

  const isPatient = user?.roles?.some((role: any) => role.name === 'Paciente')

  const handleLinkClick = () => setMenuOpen(false)

  return (
    <>
      <div className={`main-sidebar sidebar-style-2 ${menuOpen ? 'active' : ''}`}>
        <div
          className={`d-lg-none hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(false)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 28,
            height: 28,
            borderRadius: '50%',
            border: '1.5px solid #E5E7EB',
            backgroundColor: '#fff',
            color: '#6c757d',
            cursor: 'pointer',
          }}
        >
          <LuChevronLeft size={16} />
        </div>
        <div
          className="sidebar-collapse-toggle"
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? <LuChevronRight size={16} /> : <LuChevronLeft size={16} />}
        </div>
        <aside id="sidebar-wrapper">
          <div className="sidebar-brand my-4">
            <Link className="link" to="/home">
              <img src={Logotipo} alt="ProSeed" className="logo" width="200" />
            </Link>
          </div>
          <div className="sidebar-brand sidebar-brand-sm mb-5 mt-1">
            <Link className="link" to="/home">
              <img className="iconlogo" src={Iconlogo} alt="ProSeed" />
            </Link>
          </div>
          <ul className="sidebar-menu">
            {displayOnProduction() && (
              <li className={isActivated('home')} onClick={handleLinkClick}>
                <Link className="link nav-link" to="/home">
                  <LuHome size={28} className="pr-2" /> <span>Home</span>
                </Link>
              </li>
            )}
            <li className={isActivated('/')} onClick={handleLinkClick}>
              <Link className="link nav-link" to="/" target="_blank">
                <LuList size={28} className="pr-2" /> <span>Catálogo</span>
              </Link>
            </li>
            <li className={isActivated('perfil')} onClick={handleLinkClick}>
              <Link className="link nav-link" to="/perfil">
                <LuUser size={28} className="pr-2" /> <span>Perfil</span>
              </Link>
            </li>
            <li className={isActivated('favoritos')} onClick={handleLinkClick}>
              <Link className="link nav-link" to="/favoritos">
                <LuHeart size={28} className="pr-2" />
                <span>
                  Favoritos
                  {favoritesCount > 0 ? (
                    <span className="badge badge-pink favorites-badge">{favoritesCount}</span>
                  ) : null}
                </span>
              </Link>
            </li>
            {displayOnProduction() && isPatient && (
              <li className={isActivated('carrinho')} onClick={handleLinkClick}>
                <Link className="link nav-link" to="/carrinho">
                  <LuShoppingCart size={28} className="pr-2" />
                  <span>
                    Carrinho
                    {cartCount > 0 ? (
                      <span className="badge badge-pink cart-badge">{cartCount}</span>
                    ) : null}
                  </span>
                </Link>
              </li>
            )}
            {displayOnProduction() && inProgressOrders.length > 0 && (
              <li className={isActivated('pedidos')} onClick={handleLinkClick}>
                <Link className="link nav-link" to="/pedidos">
                  <LuPackage size={28} className="pr-2" /> <span>Pedidos</span>
                </Link>
              </li>
            )}
            {displayOnProduction() && inProgressOrders.length > 0 && (
              <li className={isActivated('reporte')} onClick={handleLinkClick}>
                <Link className="link nav-link" to="/reporte">
                  <LuHeartPulse size={28} className="pr-2" /> <span>Reporte sua gestação</span>
                </Link>
              </li>
            )}
            <li className={isActivated('faq')} onClick={handleLinkClick}>
              <Link className="link nav-link" to="/faq">
                <LuHelpCircle size={28} className="pr-2" /> <span>FAQ</span>
              </Link>
            </li>
            <li className={isActivated('contato')} onClick={handleLinkClick}>
              <Link className="link nav-link" to="/contato">
                <LuMessageCircle size={28} className="pr-2" /> <span>Contato</span>
              </Link>
            </li>
          </ul>
          <div className="sidebar-logout" onClick={handleLinkClick}>
            <a className="link nav-link" href="#" onClick={logout}>
              <LuLogOut size={28} className="pr-2" /> <span>Sair</span>
            </a>
          </div>
        </aside>
      </div>
      <div className={`navbar-bg ${menuOpen ? 'active' : ''}`}></div>
    </>
  )
}

export default Sidebar
